var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _RefreshToken_value;
export class RefreshToken {
    toString() {
        return __classPrivateFieldGet(this, _RefreshToken_value, "f");
    }
    getSecondsLeft() {
        return Math.floor(Math.max(0, this.expiresAt.getTime() - Date.now()) / 1000);
    }
    constructor(token, expiresAt, sub) {
        _RefreshToken_value.set(this, void 0);
        __classPrivateFieldSet(this, _RefreshToken_value, token, "f");
        this.expiresAt = expiresAt;
        this.sub = sub;
    }
    isExpired() {
        return this.getSecondsLeft() - 10 <= 0;
    }
    static fromRefreshJWT(token) {
        const value = token.split(".")[1];
        if (!value) {
            throw new Error("invalid JWT refresh token");
        }
        const decodePayload = JSON.parse(atob(value));
        const expiresAt = new Date(decodePayload["exp"] * 1000);
        return new RefreshToken(token, expiresAt, decodePayload["sub"]);
    }
}
_RefreshToken_value = new WeakMap();
export class BaseAuthState {
    constructor(token, expiresAt, expiresIn) {
        this.token = token;
        this.expiresAt = expiresAt;
        this.expiresIn = expiresIn;
    }
    isExpired() {
        return this.expiresAt.getTime() <= Date.now();
    }
}
class TenantInfo {
    hasEveryScope(scope) {
        if (typeof scope === "string") {
            return this.scopes.includes(scope);
        }
        return scope.every((s) => this.scopes.includes(s));
    }
    hasRole(role) {
        if (typeof role === "string") {
            return this.role === role;
        }
        return role.some((r) => this.role === r);
    }
    constructor(tenant) {
        this.domain = tenant.domain;
        this.id = tenant.id;
        this.type = tenant.type;
        this.role = tenant.role;
        this.scopes = tenant.scopes;
    }
}
export function getUserRefreshTokenPath(session) {
    if (session && session.tenant) {
        return `/v1/auth/tenant/${session.tenant.domain}/refresh`;
    }
    return `/v1/auth/user/session/refresh`;
}
export class UserAuthState extends BaseAuthState {
    get type() {
        return "user";
    }
    constructor(id, input, claims) {
        if (typeof id !== "string") {
            throw new Error("missing id. expect `id` to be string");
        }
        super(input.token, input.expiresAt, input.expiresIn);
        this.tenant = null;
        this.id = id;
        this.publicId = claims.identity.public_id;
        this.publicId = claims.identity.public_id;
        if (claims.tenant) {
            this.tenant = new TenantInfo(claims.tenant);
        }
    }
    static fromToken(token) {
        const tokens = token.split(".");
        const value = tokens[1];
        if (!value) {
            throw new Error("invalid user JWT access token");
        }
        const decodePayload = JSON.parse(atob(value));
        const expiresIn = decodePayload["exp"] - decodePayload["iat"];
        const expiresAt = new Date(decodePayload["exp"] * 1000);
        const identityClaims = decodePayload["identity"];
        const tenantClaims = decodePayload["tenant"];
        const id = decodePayload["sub"];
        return new UserAuthState(id, { token, expiresIn, expiresAt }, { identity: identityClaims, tenant: tenantClaims });
    }
}
export class AdminAuthState extends BaseAuthState {
    get type() {
        return "admin";
    }
    static getRefreshTokenPath() {
        return "/v1/auth/admin/session/refresh";
    }
    constructor(id, state, details) {
        super(state.token, state.expiresAt, state.expiresIn);
        if (typeof id !== "string") {
            throw new Error("missing id. expect `id` to be string");
        }
        this.id = id;
        this.role = details.role;
        this.scopes = details.scopes;
    }
    static fromToken(token) {
        const value = token.split(".")[1];
        if (!value) {
            throw new Error("invalid admin JWT access token");
        }
        const decodePayload = JSON.parse(atob(value));
        const expiresIn = decodePayload["exp"] - decodePayload["iat"];
        const expiresAt = new Date(decodePayload["exp"] * 1000);
        // rest of the body
        const adminclaims = decodePayload["admin"];
        const adminid = decodePayload["sub"];
        return new AdminAuthState(adminid, { token, expiresIn, expiresAt }, { role: adminclaims.role, scopes: adminclaims.scopes.split(/\s+/g) });
    }
}
export function authStateFromToken(token) {
    var _a;
    const tokens = token.split(".");
    const value = tokens[1];
    if (!value) {
        throw new Error("invalid user JWT access token");
    }
    // header
    const header = tokens[0];
    if (!header) {
        throw new Error("invalid user JWT access token");
    }
    const decodeHeader = JSON.parse(atob(header));
    const type = ((_a = decodeHeader["ett"]) !== null && _a !== void 0 ? _a : "user");
    if (type === "admin") {
        return AdminAuthState.fromToken(token);
    }
    return UserAuthState.fromToken(token);
}
